import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';

// Admin pages
import Login        from './pages/admin/Login';
import Dashboard    from './pages/admin/Dashboard';
import Events       from './pages/admin/Events';
import EventForm    from './pages/admin/EventForm';
import EventRegistrants from './pages/admin/EventRegistrants';
import AllRegistrants   from './pages/admin/AllRegistrants';
import Transactions from './pages/admin/Transactions';
import Config       from './pages/admin/Config';
import Broadcast    from './pages/admin/Broadcast';
import Roles        from './pages/admin/Roles';
import AdminUsers   from './pages/admin/AdminUsers';

// Public pages
import Home          from './pages/public/Home';
import EventDetail   from './pages/public/EventDetail';
import Register      from './pages/public/Register';
import VerifyEmail   from './pages/public/VerifyEmail';
import PaymentPage   from './pages/public/PaymentPage';
import PaymentSuccess from './pages/public/PaymentSuccess';
import PaymentFailed  from './pages/public/PaymentFailed';

/* ─────────────────── Protected Route ──────────────────────── */
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'100vh' }}>
      <div className="spinner" />
    </div>
  );
  return user ? children : <Navigate to="/admin/login" replace />;
}

/* ─────────────────── App Routes ───────────────────────────── */
function AppRoutes() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/"                          element={<Home />} />
      <Route path="/events/:slug"              element={<EventDetail />} />
      <Route path="/register/:slug"            element={<Register />} />
      <Route path="/verify-email"              element={<VerifyEmail />} />
      <Route path="/payment/:transactionRef"   element={<PaymentPage />} />
      <Route path="/payment-success"           element={<PaymentSuccess />} />
      <Route path="/payment-failed"            element={<PaymentFailed />} />

      {/* Admin – open */}
      <Route path="/admin/login" element={<Login />} />

      {/* Admin – protected */}
      <Route path="/admin" element={<ProtectedRoute><Navigate to="/admin/dashboard" replace /></ProtectedRoute>} />
      <Route path="/admin/dashboard"                     element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/admin/events"                        element={<ProtectedRoute><Events /></ProtectedRoute>} />
      <Route path="/admin/events/new"                    element={<ProtectedRoute><EventForm /></ProtectedRoute>} />
      <Route path="/admin/events/:id/edit"               element={<ProtectedRoute><EventForm /></ProtectedRoute>} />
      <Route path="/admin/events/:id/registrants"        element={<ProtectedRoute><EventRegistrants /></ProtectedRoute>} />
      <Route path="/admin/registrants"                   element={<ProtectedRoute><AllRegistrants /></ProtectedRoute>} />
      <Route path="/admin/transactions"                  element={<ProtectedRoute><Transactions /></ProtectedRoute>} />
      <Route path="/admin/config"                        element={<ProtectedRoute><Config /></ProtectedRoute>} />
      <Route path="/admin/broadcast"                     element={<ProtectedRoute><Broadcast /></ProtectedRoute>} />
      <Route path="/admin/roles"                         element={<ProtectedRoute><Roles /></ProtectedRoute>} />
      <Route path="/admin/users"                         element={<ProtectedRoute><AdminUsers /></ProtectedRoute>} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <AppRoutes />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
